/**
 * Every value here is copied once from `tokens.css` (`:root` for light,
 * `:root[data-theme='dark']` for dark), not read live — `createTheme()` needs
 * plain values, not CSS custom properties.
 */
import type { PaletteOptions } from '@mui/material/styles';

export const lightPalette: PaletteOptions = {
	mode: 'light',
	primary: {
		main: '#25665C',
		dark: '#00532F',
		contrastText: '#FCFCFA',
	},
	secondary: {
		main: '#646464',
	},
	error: {
		main: '#BD3627',
		dark: '#96271A',
		light: '#FBEAE7',
	},
	warning: {
		main: '#BE7E00',
		dark: '#7A5200',
		light: '#FDF4E3',
	},
	success: {
		main: '#009B72',
		dark: '#056347',
		light: '#E4F4EE',
	},
	info: {
		main: '#215CC9',
		dark: '#17408F',
		light: '#E9F0FC',
	},
	background: {
		default: '#F8FAFC',
		paper: '#FFFFFF',
	},
	text: {
		primary: '#2A2C31',
		secondary: '#68696D',
	},
	divider: '#E2E8F0',
};

export const darkPalette: PaletteOptions = {
	mode: 'dark',
	primary: {
		main: '#3A9384',
		dark: '#2F7D70',
		light: '#5FB3A3',
		contrastText: '#FCFCFA',
	},
	secondary: {
		main: '#B4BAC2',
	},
	error: {
		main: '#E05A4A',
		dark: '#F2A196',
		light: '#3A1A17',
	},
	warning: {
		main: '#E0A028',
		dark: '#F1C76B',
		light: '#33270F',
	},
	success: {
		main: '#2BBF8F',
		dark: '#7FD9B6',
		light: '#0F2E24',
	},
	info: {
		main: '#5B8EF0',
		dark: '#A3C0F7',
		light: '#15233D',
	},
	background: {
		default: '#0F1419',
		paper: '#171C22',
	},
	text: {
		primary: '#E6E8EB',
		secondary: '#8F97A1',
	},
	divider: '#2A323B',
};
